import { useState } from "react";
import CurrencyInput from "react-currency-input-field";
import { BOGItems, BOGDisclaimer } from './BasketOfGoods'
import { DeleteIcon } from "../../image/icons";

export const FooterButtons = (
  state,
  assesmentPopupShow,
  disableButton,
  isValidQR,
  applicationType,
  silComProduct,
  selectedCompetitors,
  pageSource
) => {
  const enableSMSBtn = state.promoterDetails?.isSMSEnabled && state.promoterDetails.isSMSEnabled === 1;
  const isVip = pageSource === "vip";
  const isDisabled = disableButton || isValidQR || (applicationType?.productName === silComProduct && selectedCompetitors?.length === 0);
  return (
        <div className="Next-btn">
            <div className="next-page-btn">
                {isVip ? (
                    <button
                        className="btn btn-dark"
                        onClick={() => assesmentPopupShow('push-qr')}
                        disabled={isDisabled}
                    >
                        Submit Application{" "}
                        <i className="fa fa-arrow-right" aria-hidden="true"></i>
                    </button>
                ) : (
                    <>
                        {enableSMSBtn && (
                            <button
                                className="btn btn-dark"
                                onClick={() => assesmentPopupShow('push-sms')}
                                disabled={isDisabled}
                            >
                                Send SMS
                                <i className="fa fa-arrow-right" aria-hidden="true"></i>
                            </button>
                        )}
                        <button
                            className="btn btn-dark"
                            onClick={() => assesmentPopupShow('push-qr')}
                            disabled={isDisabled}
                        >
                            Generate QR Code{" "}
                            <i className="fa fa-arrow-right" aria-hidden="true"></i>
                        </button>
                    </>
                )} 
            </div>
        </div>
    );
};

export const ItemsList = ({ logic }) => {
  return (
    <div className="item-details">
      <div className="item-details-desc">
        <div className="title">Add to cart</div>
        <div className="sub-title">
          I-add ang item na gusto ni client bilhin gamit ang loan. You
          can bundle up to 3 items per QR code
        </div>
        <br />
        <div className="items-list">
          <div className="container">
            <div className="row row-flex">
              {logic.allItems.length > 0 && (
                <>
                  {logic.allItems.map((field, index) => (
                    <div key={index} className="col-lg-4 col-md-6 col-sm-12">
                      <div className="add-player-div d-flex flex-column py-4 px-3">
                        <div className="item-header d-flex justify-content-between align-items-center pb-4">
                          <h4 className="text-dark mb-0">
                            ITEM {index + 1}
                          </h4>
                          {index > 0 && (
                            <div className="delete-item" onClick={() => logic.handleDeleteItems(index)}>
                              <DeleteIcon />
                            </div>
                          )}
                        </div>
                        <form key={index}>
                          <select
                            name="categoryName"
                            placeholder="Enter Category"
                            className="mb-3 form-select form-control uppercase-input category-name"
                            value={field.productDescription}
                            onChange={(e) => {
                              logic.handleInputChange(e, index);
                            }}
                            defaultValue={''}
                          >
                            <option
                              disabled={true}
                              value=""
                            >
                              Category
                            </option>
                            {logic.merchantStore.map((items, catIndex) => {
                              if (index !== 0 && logic.basketOfFinanceProduct in items && items[logic.basketOfFinanceProduct] === "Y") {
                                return null;
                              }
                              return (
                                <option
                                  key={catIndex}
                                  id={items.productId}
                                  data-interestrate={
                                    items.productDownpayment
                                  }
                                  data-priority={
                                    (items.priority) ? items.priority : '--'
                                  }
                                  data-productid={
                                    (items.productId) ? items.productId : '--'
                                  }
                                  value={items.productDescription}
                                >
                                  {items.productDescription}
                                </option>
                              );
                            })}
                          </select>
                          <input
                            type="text"
                            name="brand"
                            data-id={index}
                            placeholder="Brand"
                            maxLength="50"
                            className="mb-3 form-control uppercase-input"
                            value={field.brand}
                            onChange={(e) =>
                              logic.handleInputChange(e, index)
                            }
                          />

                          <input
                            type="text"
                            name="skuNo"
                            data-id={index}
                            placeholder="SKU"
                            maxLength="50"
                            className="mb-3 form-control uppercase-input"
                            value={field.sku}
                            onChange={(e) =>
                              logic.handleInputChange(e, index)
                            }
                          />

                          <CurrencyInput
                            intlConfig={{ locale: 'en-PH', currency: 'PHP' }}
                            id="amount"
                            maxLength={6}
                            className="mb-3 form-control uppercase-input"
                            prefix="₱"
                            name="amount"
                            placeholder="Price"
                            onChange={(e) =>
                              logic.handleInputChange(e, index)
                            }
                            onKeyDown={(e) =>
                              logic.handleDecimalNumbers(e)
                            }
                            onInput={(e) =>
                              logic.handlePasteDecimalNumbers(e)
                            }
                          />

                          <BOGDisclaimer logic={logic} />
                        </form>
                      </div>
                    </div>
                  ))}
                </>
              )}
              {logic.allItems.length <= 2 && (
                <>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="add-player-div add-new-item d-flex justify-content-center align-items-center py-4 px-3">
                      <div className="Add-btn p-4 text-dark">
                        <p className={logic.isBasketFinance || logic.solarFinance ? "text-muted" : ""} onClick={() => (!logic.isBasketFinance && !logic.solarFinance) && logic.handleAddItems()}>
                          + Add more item
                        </p>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
            <BOGItems isShow={logic.isBasketFinance} enableQrGenerator={logic.enableQrGenerator} />

          </div>
        </div>
      </div>
    </div>
  )
}

export const ToggleButton = () => {
  const [toggle, setToggle] = useState(false);
  function toggleMenu() {
    setToggle(!toggle);
  }
  return (
    <div className="toggle-btn">
      <button
        className="btn btn-light"
        onClick={() => {
          toggleMenu();
        }}
      >
        <i className="fa fa-align-justify" aria-hidden="true"></i>
      </button>
    </div>
  )
}